import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../components/header/header.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { ButtonComponent } from '../../components/button/button.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { GlobalService } from '../../services/global.service';
import { ExamService } from '../../services/exam.service';
import { DropdownService } from '../../services/dropdown.service';
import { ValidationService } from '../../services/validation.service';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';

@Component({
  selector: 'app-exam-form-page',
  imports: [CommonModule, ReactiveFormsModule, HeaderComponent, TextInputComponent, ButtonComponent, SelectInputComponent, FilterByKeyAndValuePipe],
  templateUrl: './exam-form-page.component.html',
  styleUrl: './exam-form-page.component.css'
})
export class ExamFormPageComponent {
  form: FormGroup;
  selected_item: any = {};
  isSubmitting = false;

  constructor(
    public gs: GlobalService,
    public es: ExamService,
    public dds: DropdownService,
    public vs: ValidationService,
    public fb: FormBuilder,
    public route: Router,
    public ar: ActivatedRoute,
  ) {
    this.form = this.fb.group({
      academic_year_id: ['', [Validators.required]],
      university_id: ['', [Validators.required]],
      college_id: ['', [Validators.required]],
      level_id: ['', [Validators.required]],
      program_id: ['', [Validators.required]],
      stream_id: ['', [Validators.required]],
      credits: ['', [Validators.pattern('^(?:[0-9]|1[0-9]|20)$')]],
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      contact: ['', [Validators.minLength(this.vs.min_length_contact), Validators.maxLength(this.vs.max_length_contact)]],
      email: ['', [Validators.pattern(this.vs.email_pattern), Validators.maxLength(this.vs.max_length_email)]],
      is_active: [true]
    });
  }

  async ngOnInit() {
    await this.dds?.get_dropdown_list(['academic-year', 'university', 'college', 'level', 'stream', 'program']);
    this.ar.queryParams.subscribe(async params => {
      if (params['id']) {
        const res = await this.es.get(params['id']);
        this.selected_item = this.gs.addHierarchyIds({ ...res?.data }) || {};
        this.form.patchValue({
          academic_year_id: this.selected_item.academic_year_id,
          university_id: this.selected_item.university_id,
          level_id: this.selected_item.level_id,
          stream_id: this.selected_item.stream_id,
          credits: this.selected_item.credits,
          name: this.selected_item.name,
          code: this.selected_item.code,
          contact: this.selected_item.contact,
          email: this.selected_item.email,
          is_active: this.selected_item.is_active,
        });
        setTimeout(() => {
          this.form.patchValue({
            college_id: this.selected_item.college_id,
            program_id: this.selected_item.program_id,
          });
        });
      }
    });
  }

  discard() {
    this.route.navigate(['/exam/list']);
  }

  async submit() {
    if (this.isSubmitting) return;
    if (this.form.invalid) {
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;
    try {
      const value = { ...this.form.value, is_active: true };
      if (this.selected_item?.id) {
        await this.es.update(this.selected_item.id, value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        const res = await this.es.add(value);
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.dds.invalidate_dropdown_cache('exam');
      this.route.navigate(['/exam/list']);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }
}
